export * from './bodata';
export * from './propdata';
export * from './boadmin-base.component';
